import * as React$1 from "react";

//#region src/components/icon/static/mail-order.svg
var _path, _path2;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgMailOrder = function SvgMailOrder$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", { d: "M6 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0" })), _path2 || (_path2 = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M7 3.85A5.15 5.15 0 0 0 1.85 9v9A2.15 2.15 0 0 0 4 20.15h16A2.15 2.15 0 0 0 22.15 18V9A5.15 5.15 0 0 0 17 3.85zm0 2.3A2.85 2.85 0 0 0 4.15 9v8.85h5.7V9A2.85 2.85 0 0 0 7 6.15m5.15 5v6.7h7.7V9A2.85 2.85 0 0 0 17 6.15h-5.71c.518.777.83 1.703.858 2.7H16.5c.911 0 1.65.739 1.65 1.65V13a1.15 1.15 0 0 1-2.3 0v-1.85z",
		clipRule: "evenodd"
	})));
};
var mail_order_default = SvgMailOrder;

//#endregion
export { mail_order_default as default };